export const keypressCommaControl = (event: KeyboardEvent): void => {
  if (event.code === 'Comma') {
    // invalid character, prevent input
    event.preventDefault();
  }
};
